import { Dialog } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useResetRecoilState } from "recoil";
import { CloseIcon } from "../../../../assets/Icons";
import Loader from "../../../../components/ui/Loader";
import { initializeTransaction } from "../../../../services/offline";
import { declarationDefault, isEsigned, offlineSBM, transactionDetails } from "../../../../store";
import { Calculation } from "./Calculation";
import { Modals } from "./Modals";
import { PaymentOverview } from "./PaymentOverview";
import { getSignedStatus, signLaterStatus } from "../../../../services/reviewPage";
import EsignModalOffline from "./EsignModalOffline";
import { getVendorCodes } from "../../../../services/review";

const OfflineSBMReview = () => {
  const [taxStep, stepTaxStep] = useState<boolean>(false);
  const [isModalOpen, setIsModalOpen] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const offlineRemitter = JSON.parse(localStorage.getItem("offlineRemitter") || "{}");
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const [dualNumber, setDualNumber] = useState<string>("");
  const [referrer, setReferrer] = useState<string>("");
  const [finalModal, showFinalModal] = useState<boolean>(false);
  const [transactionID, setTransactionID] = useState<string>("");
  const [offlineSbmData, setOfflineSbmData] = useRecoilState(offlineSBM);
  const [signA2FormStatus, setSignA2FormStatus] = React.useState<boolean>(false);
  const eSignStatus = useRecoilState(isEsigned)[0];
  const [vendorCodes, setVendorCodes] = useState<any>([]);
  const [isEsignModal, setIsEsignModal] = React.useState<boolean>(false);
  const [eSign, setEsign] = React.useState<boolean>(false);
  const [signLater, setSignLater] = React.useState<boolean>(false);
  const [linkSent, setLinkSent] = React.useState<boolean>(false);
  const resetTransaction = useResetRecoilState(transactionDetails);
  const resetDeclaration = useResetRecoilState(declarationDefault);
  const userId = localStorage.getItem("remitterToken");

  const isPurposeCodeValid = (purposeCode: string) => {
    return purposeCode === "S1301" || purposeCode === "S1302" ? true : false;
  };

  useEffect(() => {
    window.onbeforeunload = function () {
      return true;
    };

    return () => {
      window.onbeforeunload = null;
    };
  }, []);
  const handleInitializeTransaction = (e: any) => {
    setLoading(true);
    e.preventDefault();
    const body = {
      ...offlineSbmData,
      modeOfTransaction: "Offline",
      vendor_key: currentUser.vendor_key,
      userId: userId,
      id_recipient: offlineSbmData.id_recipient,
      transactionLeadIds: Object.values(offlineSbmData.transactionLeadIds),
      isAdvancePay: false,
      isFullPay: true,
    };
    initializeTransaction(offlineRemitter, currentUser, body)
      .then((response: any) => {
        showFinalModal(true);
        localStorage.setItem("onlyNeft", String(isPurposeCodeValid(response?.data?.purposeCode)));
        setOfflineSbmData(response?.data);
        setTransactionID(response?.data?.transactionNumber);
      })
      .catch((error: any) => {
        console.error(error);
      })
      .finally(() => setLoading(false));
  };

  const getCodes = () => {
    getVendorCodes(currentUser).then((response: any) => {
      const codeArray: string[] = [];
      response.data.forEach((element: any) => {
        codeArray.push(element.value);
      });
      setVendorCodes(codeArray);
    });
  };
  useEffect(() => {
    getCodes();
  }, []);

  useEffect(() => {
    if (eSignStatus.signed && eSignStatus.signedLater) {
      setSignA2FormStatus(true);
    } else {
      setSignA2FormStatus(false);
    }
  }, []);

  const handleSignA2Form = () => {
    setIsEsignModal(true);
  };

  const handleDoLaterA2Form = () => {
    const vendorUserKey = JSON.parse(localStorage.getItem("offlineRemitter") || "{}");
    signLaterStatus({
      userId: vendorUserKey.user_key,
    })
      .then((response) => {
        if (response) {
          setIsEsignModal(false);
        }
      })
      .catch((error) => {
        alert(error?.response?.data?.error?.type);
      });
  };

  const handleLinkSent = () => {
    setIsEsignModal(false);
    setLinkSent(true);
  };

  useEffect(() => {
    handleEsignedStatus();
  }, [isEsignModal]);

  const handleEsignedStatus = () => {
    const vendorUserKey = JSON.parse(localStorage.getItem("offlineRemitter") || "{}");
    getSignedStatus({
      userId: vendorUserKey.user_key,
    })
      .then((response) => {
        setSignLater(response?.data?.signedLatter);
        setEsign(response?.data?.signed);
        setLinkSent(response?.data?.signLinkSent);
      })
      .catch((error) => {
        alert(error?.response?.data?.error?.type);
      });
  };

  return (
    <div className="w-[1330px]">
      {loading === false ? (
        <div>
          <div id="header" className="flex items-center justify-between px-10 py-5 mt-8">
            <div id="left" className="flex flex-col">
              <span className="text-[28px] font-bold">Review</span>
              <span className="text-[20px] font-semibold">
                Please review the details before continuing with your transaction.... good
              </span>
            </div>
            <div id="right" onClick={() => navigate("/home")} className="mr-5 cursor-pointer">
              <CloseIcon fill="black" />
            </div>
          </div>
          <div id="content" className="flex h-[1000px] ">
            <div id="left" className="flex flex-col items-center w-1/2 mt-20">
              {/* <RemittanceDetails /> */}
              <Calculation taxStep={taxStep} setTaxStep={stepTaxStep} />
            </div>
            <div className="border-l-4 h-[750px] border-gray-300 mt-6"></div>
            <div id="right" className="flex flex-col items-center w-1/2">
              <div className="py-5"></div>
              <div className="">
                <PaymentOverview
                  handleClick={handleInitializeTransaction}
                  isModalOpen={isModalOpen}
                  setIsModalOpen={setIsModalOpen}
                  dualNumber={dualNumber}
                  setDualNumber={setDualNumber}
                  verifyDual={handleInitializeTransaction}
                  referrer={referrer}
                  isLoading={loading}
                  setReferrer={setReferrer}
                  signA2FormStatus={signA2FormStatus}
                  handleSignA2Form={handleSignA2Form}
                  eSign={eSign}
                  signLater={signLater}
                  linkSent={linkSent}
                  vendorCodes={vendorCodes}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="flex items-center justify-center w-[500px] h-[500px] ml-[450px] mt-[150px]">
          <Loader />
        </div>
      )}
      <Modals isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
      <Dialog open={finalModal} onClose={() => showFinalModal(false)}>
        <div className="px-8 py-3 font-bold text-white bg-green-600">Offline Transaction</div>
        <div className="flex flex-col items-center px-10 py-4 space-y-2">
          <span className="font-bold text-[16px]">Transaction Completed</span>
          <span className="font-bold text-[16px]">Transaction ID: {transactionID} </span>
          <div
            onClick={() => {
              navigate("/history");
              resetTransaction();
              resetDeclaration();
            }}
            className="px-6 py-2 font-bold text-white rounded cursor-pointer bg-primary"
          >
            Go to History
          </div>
        </div>
      </Dialog>
      <EsignModalOffline
        isEsignModal={isEsignModal}
        setIsEsignModal={setIsEsignModal}
        handleDoLaterA2Form={handleDoLaterA2Form}
        handleLinkSent={handleLinkSent}
      />
    </div>
  );
};

export default OfflineSBMReview;
